import http from "../http"

export function getCart() {
  return http.get("/buyer/cart")
}

export function getCartCount() {
  return http.get("/buyer/cart/count")
}

export function addCart(params) {
  return http.post("/buyer/cart/add", params)
}

export function addCartByTransaction(transactionId) {
  return http.post(`/buyer/cart/add-by-transaction/${transactionId}`)
}

export function updateCart(cardId, params) {
  return http.put(`/buyer/cart/update/${cardId}`, params)
}
